module.exports = __webpack_public_path__ + "assets/img/sabc_contact_m.webp?b1207df8a3ed11aaec7ff46d6a45e695";